<template>
    <div class='main'>
        <div class='content'>
            <h5>保護者登録用リンク</h5>
            <p class='selectSchool'>選択中の学校: {{ schoolName }} </p>
            <p class='selectYear'>選択中の学年: {{ yearName }} </p>
            <input id='link' class='link' :value='link' readonly>
            <button class='button is-primary' @click='copy'>コピー</button>
        </div>
    </div>
</template>

<script>

export default {
    name: 'RegisterLink',
    props: ['schoolMap', 'selectSchoolId', 'selectYearId'],
    data () {
        return {
            link: '',
            schoolName: '未選択',
            yearName: '未選択'
        }
    },
    watch: {
        selectSchoolId () {
            this.displayLink()
        },
        selectYearId () {
            this.displayLink()
        }
    },
    mounted () {
        this.displayLink()
    },
    methods: {
        displayLink () {
            const schoolId = this.selectSchoolId
            const yearId = this.selectYearId
            const baseUrl = process.env.API_URL.split('/v1')[0]

            if (this.schoolMap[schoolId]) this.schoolName = this.schoolMap[schoolId].name

            if (!this.schoolMap[schoolId] || !this.schoolMap[schoolId].years[yearId]) {
                this.yearName = ''
                this.link = ''
                return
            }

            this.yearName = this.schoolMap[schoolId].years[yearId].name

            this.link = `${baseUrl}/#/register/${this.schoolMap[schoolId].years[yearId].url}`
        },
        copy () {
            const link = document.querySelector('#link')

            link.select()
            document.execCommand('Copy')

            this.$root.$emit('notification', 'is-success', `リンクをクリップボードにコピーしました`)
        }
    }
}
</script>

<style scoped>

.content {
    margin: 30px;
}

.link {
    padding: 5px;
    padding-left: 10px;
    height: 40px;
    width: 450px;
    font-size: 17px;
}

.button {
    margin-left: 15px;
}

.selectSchool {
    margin-bottom: 0 !important;
}

</style>



// WEBPACK FOOTER //
// src/components/photographer/pages/RegisterLink.vue